import React, { useEffect } from 'react'
import styles from './flexStyles.module.scss'
import {logo, photo, experience} from '../../../assets/img/dashCategoris'
import { arrowLeft, closeIcon, questionIcon, arrow, checkGreen } from '../../../assets/svg/dashboard/main'
import { useHistory, useLocation, useRouteMatch, useParams } from 'react-router-dom'
import { eduIcon5 } from '../../../assets/img/dashCategoris'
import { image1, image2, image3, image4, image5, image6, image7, image8 } from '../../../assets/img/dashCriterias'
import { Check } from '../../../assets/NewDashboard'
import { getEiocDetails, getFile } from '../../../actions/dashboard'
import { useDispatch, useSelector } from 'react-redux'
import ReactLoader from 'react-loader'
import { createNotification } from '../../../components/notifications/notifications'
import { files } from '../../../actions/currentPerformance'
import ReactTooltip from 'react-tooltip'
import { DASHBOARD_ENTITIES } from '../../../utils/const'


const CARDS = {
  high: [
    {name: 'Доступ к электронному расписанию', image: image1, entity: 'has_schedule', link: '/schedule'},
    {name: 'Наличие доступа к Интернету', image: image2, entity: 'has_internet_access', files: 'internet_files'},
    {name: 'Доступ к электр. образоват. ресурсам', image: image3, entity: 'has_library_access', files: 'doc_files', link: '/library'},
    {name: 'Локальный нормативный акт об ЭИОС', image: image4, entity: 'has_local_act', files: 'local_act_files'},
    {name: 'Наличие возможности взаимодействия педагогов с обучающимися в ЭИОС', image: image5, entity: 'has_teacher_interactions', link: '/messages'},
    {name: 'Наличие доступа к учебным планам, рабочим программам дисциплин и т.п.', image: image6, entity: 'has_up_rpd', link: '/program_modules', missing: 'missing_rpds'},
    {name: 'Наличие доступа к электронной библиотечной системе', image: image7, entity: 'has_doc', files: 'doc_files'},
    {name: 'Наличие возможности формирования электронного портфолио', image: image8, entity: 'has_portfolio_formation', link: '/portfolio', missing: 'missing_hobby'},
  ],
  spo: [
    {name: 'Электронное расписание', image: image1, entity: 'has_schedule', link: '/schedule'},
    {name: 'Наличие доступа к Интернету', image: image2, entity: 'has_internet_access', files: 'internet_files'},
    {name: 'Электронные образовательные ресурсы', image: image3, entity: 'has_library_access', files: 'doc_files', link: '/library'},
    {name: 'Локальный нормативный акт об ЭИОС', image: image4, entity: 'has_local_act', files: 'local_act_files'},
    {name: 'Взаимодействие между участниками образовательного процесса', image: image5, entity: 'has_teacher_interactions', link: '/messages'},
    {name: 'Наличие доступа к электронному журналу', image: image6, entity: 'has_up_rpd', link: '/journal'},
    {name: 'Наличие доступа к электронной библиотечной системе', image: image7, entity: 'has_doc', files: 'doc_files'},
    {name: 'Наличие личного кабинета', image: image8, entity: 'has_portfolio_formation', link: '/portfolio'},
  ]
} 

const Details = ({ spoMode }) => {
  
  const history = useHistory()
  const {id} = useParams()
  
  const dispatch = useDispatch()
  const {details, loading} = useSelector(state => state.dashboard)

  useEffect(() => {
    if (!parseInt(id)) return;
    dispatch(getEiocDetails(id, spoMode))
  }, [])
  
  const goTo = (link) => () => history.push(link) 


  const onDocsClick = (docs) => () => {
    if (!docs?.files.length) return createNotification('error', 'Документ-подтверждение отсутствует');
    const {f_doc_hs, files} = docs
    getFile(f_doc_hs, files[0].file)
  }

  const renderCard = (card, index) => {
    const {name, image, entity, files, link, missing} = card
    if (!Object.keys(details.eioc)?.length) return;
    const checkMode = details.eioc[entity] ? 'complete' : 'notComplete'
    const onClickCB = link ? goTo(link) : onDocsClick(details.eioc[files][0])
    const clickBlockTitle = link ? 'Перейти к электронной системе' : 'Документ'
    const missingList = details.eioc[missing]
    return (
      <li key={index}>
        <img src={image} alt={name} />
        <p>{name}</p>
        <Check mode={checkMode} className={styles.checkBlock}/>
        {missingList &&
          <ul>
            {missingList.map(({id, mid, fio, name}) => <li key={id || mid}>{name || fio}</li>)}
          </ul>
        }
        <div onClick={onClickCB}>
          <span>{clickBlockTitle}</span>
          {arrow}
        </div>
      </li>
    )
  }

  const {name, result} = details.eioc
  const { min, max, options } = DASHBOARD_ENTITIES[spoMode ? 'spo' : 'high'].eioc

  return (
    <div>
        <section className={styles.wrapper}>

        <div onClick={goTo(`/dashboard_new/accreditation${spoMode ? '?level=spo' : ''}`)}>
          <div>{arrowLeft}</div>
          <h2>{name}</h2>
        </div>
        
        <div className={styles.descriptionBlock}>
          <div>
            <div>
              <img src={eduIcon5} alt='о_О' />
              <p>Электронная информационно-образовательная среда</p>
            </div>
            <div>
              {result < max ? 'не имеется' : 'имеется'}
              {result < max ? closeIcon : checkGreen}
            </div>
          </div>
          <div>
            <div>
              <i data-tip='custom-jsx-tooltip' data-for="custom-jsx-tooltip">{questionIcon}</i>
              <ReactTooltip id="custom-jsx-tooltip" className={styles.tooltip}>
                <p>Критериальное значение аккредитационного показателя</p>
                <ul>{options.map((i) => <li>{i}</li>)}</ul>
              </ReactTooltip>
              <Check
                className={styles.checkBlock}
                mode={result >= max ? `complete` : result <= min ? `notComplete` : `middle`}
              />
            </div>
            <p>{result}</p>
            <p>баллов</p>
            <p>аккредитационного показателя</p>
          </div>
        </div>

        <ul>
          {CARDS[spoMode ? 'spo' : 'high'].map(renderCard)}
        </ul>

      </section>
    </div>
  )
}

export default Details